import { namespace } from './namespace';

export const CHECK_OPTION = namespace + '/CHECK_OPTION';
export const UNCHECK_OPTION = namespace + '/UNCHECK_OPTION';
export const SAVE_RESPONSE = namespace + '/SAVE_RESPONSE';
export const SHUFFLE_OPTIONS = namespace + '/SHUFFLE_OPTIONS';
export const REVERSE_OPTIONS = namespace + '/REVERSE_OPTIONS';
